import React, {useEffect, useId, useState} from 'react'
import { singletonFetch } from 'MODULES/singletonFetch'
import DatePicker from 'react-datepicker'
import { registerLocale, setDefaultLocale } from 'react-datepicker'
import da from 'date-fns/locale/da'
import de from 'date-fns/locale/de'
import enUS from 'date-fns/locale/en-US'
import OpeningDaysCalendarSliderWeeks from './OpeningDaysCalendarSliderWeeks'
import 'react-datepicker/dist/react-datepicker.css'
import SpinnerOverlay from '../SpinnerOverlay'
import {sprintf} from "sprintf-js";


export default function OpeningDaysCalendarSlider (props) {

  registerLocale('da_DK', da)
  registerLocale('en_US', enUS)
  registerLocale('de_DE', de)

  setDefaultLocale(props.locale);

  const id = useId()

  const [openingDays, setOpeningDays] = useState(props.openingDays)

  const [currentWeek, setCurrentWeek] = useState({
    start: new Date(openingDays[0].date),
    end: new Date(openingDays[6].date),
    week: getWeekNumber(new Date(openingDays[0].date))
  })

  const [minDate] = useState(new Date(openingDays[0].date))

  const [highlightedDates, setHighlightedDates] = useState(Object.values(openingDays).map(openingDay => {
    return new Date(openingDay.date)
  }))

  const [isLoading, setIsLoading] = useState(false)

  const UpdateOpeningDays = async function () {

    setIsLoading(true)

    return await singletonFetch(
      'update_opening_days_' + id,
      props.updateOpeningDaysRestUrl + getFormattedDate(currentWeek.start) + ':' + getFormattedDate(currentWeek.end),
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    ).then(response => {
      return response.json()
    }).then(data => {
      if (data.openingDays) {
        setOpeningDays(data.openingDays)
      }
    }).finally(() => {setIsLoading(false)}
    )
  }

  function getWeekNumber (d) {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)

    return weekNo
  }

  function getPreviousMonday (date) {
    while (date.getDay() !== 1) {
      date.setDate(date.getDate() - 1)
    }

    return date
  }

  function getNextSunday (date) {
    while (date.getDay() !== 0) {
      date.setDate(date.getDate() + 1)
    }

    return date
  }

  function getNextMonday (date) {
    date.setDate(date.getDate() + 1)

    while (date.getDay() !== 1) {
      date.setDate(date.getDate() + 1)
    }

    return date
  }

  function updateDate(date){
    setCurrentWeek({
      start: getPreviousMonday(new Date(date.valueOf())),
      end: getNextSunday(new Date(date.valueOf())),
      week: getWeekNumber(new Date(date.valueOf()))
    })
  }

  function selectNextWeek(){
    let clone = new Date(currentWeek.end.valueOf())
    updateDate(clone.setDate(clone.getDate() + 1))
  }

  function selectPreviousWeek(){
    let clone = new Date(currentWeek.start.valueOf())
    updateDate(clone.setDate(clone.getDate() - 1))
  }

  function getFormattedDate (date) {
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
  }

  useEffect(() => {
    UpdateOpeningDays()
  }, [currentWeek])

  useEffect(() => {
    setHighlightedDates(Object.values(openingDays).map(openingDay => {
      return new Date(openingDay.date)
    }))
  }, [openingDays])

  return (
    <React.Fragment>
      {
        isLoading
        ? <SpinnerOverlay/>
          : null
      }
      <div className="mtt-opening-hours__inner page_container">
        <div className="mtt-opening-hours__topbar">
          {typeof props.args.title === 'string' && props.args.title.length > 0 ?
            <div className="mtt-opening-hours__topbar--title">
              <h2 className="title--h3">{props.args.title}</h2>
            </div>
            : null
          }

          <div className="mtt-opening-hours__topbar--date">
            <label>
              <svg xmlns="http://www.w3.org/2000/svg" width="24.011" height="24" viewBox="0 0 24.011 24">
                <path data-name="Path 9715"
                      d="M19.375,1.958h-.9V1.051a.938.938,0,1,0-1.875,0v.906h-9.2V1.051a.938.938,0,0,0-1.875,0v.906h-.9A4.641,4.641,0,0,0,0,6.593V19.478a4.641,4.641,0,0,0,4.636,4.636H19.375a4.641,4.641,0,0,0,4.636-4.636V6.593a4.641,4.641,0,0,0-4.636-4.636ZM4.636,3.833h.9V5.661a.938.938,0,0,0,1.875,0V3.833h9.2V5.661a.938.938,0,0,0,1.875,0V3.833h.9a2.764,2.764,0,0,1,2.761,2.761v.9H1.875v-.9A2.764,2.764,0,0,1,4.636,3.833ZM19.375,22.239H4.636a2.764,2.764,0,0,1-2.761-2.761V9.364H22.136V19.478a2.764,2.764,0,0,1-2.761,2.761ZM8.328,13.052a.937.937,0,0,1-.937.938H5.547a.938.938,0,0,1,0-1.875H7.391A.938.938,0,0,1,8.328,13.052Zm11.073,0a.937.937,0,0,1-.938.938H16.62a.938.938,0,0,1,0-1.875h1.844A.938.938,0,0,1,19.4,13.052Zm-5.542,0a.937.937,0,0,1-.937.938H11.078a.938.938,0,1,1,0-1.875h1.844A.938.938,0,0,1,13.859,13.052ZM8.328,18.583a.937.937,0,0,1-.937.937H5.547a.937.937,0,1,1,0-1.875H7.391A.938.938,0,0,1,8.328,18.583Zm11.073,0a.937.937,0,0,1-.938.937H16.62a.937.937,0,1,1,0-1.875h1.844A.938.938,0,0,1,19.4,18.583Zm-5.542,0a.937.937,0,0,1-.937.937H11.078a.937.937,0,1,1,0-1.875h1.844A.938.938,0,0,1,13.859,18.583Z"
                      transform="translate(0 -0.114)" fill="#fff"/>
              </svg>
              <p className="title--h3 mtt-opening-hours__current-week" dangerouslySetInnerHTML={{ __html: sprintf(props.args.textWeek, '<span>' + currentWeek.week + '</span>')}}></p>
              <DatePicker
                showWeekNumbers={true}
                minDate={minDate}
                focusSelectedMonth={true}
                calendarStartDay={1}
                selected={currentWeek.start}
                onChange={(date) => updateDate(new Date(date.valueOf()))}
                highlightDates={highlightedDates}
              />
            </label>

            <div className="mtt-arrows">
              <div className={'mtt-arrow mtt-arrow--prev' + (minDate.toDateString() === currentWeek.start.toDateString() ? ' disabled' : '')} onClick={selectPreviousWeek}/>
              <div className="mtt-arrow mtt-arrow--next" onClick={selectNextWeek}/>
            </div>
          </div>
        </div>

        <div className="mtt-opening-hours__dates">
          <OpeningDaysCalendarSliderWeeks openingDays={openingDays} />
        </div>
      </div>
    </React.Fragment>
  )
}
